var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-result',{attrs:{"status":"success","title":_vm.title,"sub-title":("" + (_vm.$moment().format('YYYY-MM-DD hh:mm:ss')))}})}
var staticRenderFns = []

export { render, staticRenderFns }